import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { Section } from "../components/Section";
import Reveal from "../components/Reveal";

/** The marina's own Employment copy, carried over verbatim. The application is a
 *  download returned in person -- there is no online form. */
export default function Employment() {
  return (
    <>
      <Seo
        title="Employment | West Branch Marina"
        description="We are always looking for quality people to join us at West Branch and Lake Milton Marina."
        path="/employment"
      />

      <PageHero
        eyebrow="Employment"
        title="We are always looking for quality people to join us at West Branch and Lake Milton Marina."
      />

      <Section tone="white">
        <div className="grid gap-10 lg:grid-cols-[1fr_1fr] lg:items-center lg:gap-16">
          <Reveal>
            <p data-testid="employment-intro" className="text-base leading-relaxed text-slate-700">
              If you are interested in employment with us please complete the application which can be
              downloaded from the link below. Return the completed application in person at the West
              Branch Marina. We looking forward to meeting you!
            </p>
            <a
              href="/site-assets/employment/Employment-application.pdf"
              download
              data-testid="employment-application-link"
              className="mt-8 inline-flex items-center gap-3 rounded-full bg-ember px-7 py-4 font-bold text-white transition-all hover:bg-ember-hover hover:-translate-y-0.5"
            >
              Application
            </a>
          </Reveal>
          <Reveal delay={90}>
            <img
              src="/site-assets/employment/employment.png"
              alt="Marina crew at work"
              data-testid="employment-image"
              className="w-full rounded-3xl border border-sand-border object-cover"
              loading="lazy"
            />
          </Reveal>
        </div>
      </Section>
    </>
  );
}
